@if (roleCode()) {
  <a
    class="__chip"
    [class.__chip--full]="isFullAccess()"
    [class.__chip--read]="!isFullAccess()"
    [routerLink]="settingsLink()">
    {{ roleLabel() }}
  </a>
}
